import { render, staticRenderFns } from "./editBatch.vue?vue&type=template&id=f3507538&scoped=true"
import script from "./editBatch.vue?vue&type=script&lang=js"
export * from "./editBatch.vue?vue&type=script&lang=js"
import style0 from "./editBatch.vue?vue&type=style&index=0&id=f3507538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3507538",
  null
  
)

export default component.exports